module.exports = __webpack_public_path__ + "h5/img/score.5c9a8afb.png";